import { parseFlight } from "helpers/flightHelper";
import { useFlightContext } from "hooks/flight/useFlightContext";
import useApiClient from "hooks/useApiClient";
import { useTranslation } from "react-i18next";
import flightIcon from "../../assets/img/icon/plane-right-blue.png";
import { FaPlane } from "react-icons/fa6";
import useToggle from "hooks/useToggle";
import { BsEyeFill } from "react-icons/bs";
import FlightDetailModal from "component/FlightSearch/FlightDetailsModal";

const FlightDetails = () => {
    const { airValidateResults, availabilityResults, flightSearchParams } = useFlightContext();
    const { flight } = airValidateResults || {};
    const { t } = useTranslation();
    const { isOpen, toggle } = useToggle();
    const { airlineDictionary, airportDictionary } = availabilityResults || {};
    const parsedFlight = parseFlight(
        flight,
        airportDictionary,
        airlineDictionary
    );

    if (!flight) return null;

    return (
        <div className={`w-full border border-border-color rounded-lg `}>
            <div className="w-full px-3 pt-2 flex justify-start items-center">
                <div
                    onClick={toggle}
                    className="flex  flex-row bg-transparent  border-none text-secondary-color cursor-pointer items-center"
                >
                    <BsEyeFill className=" me-1" />
                    <span className="">{t("flightDetails")}</span>
                </div>
            </div>
            {parsedFlight?.bounds.map((bound, index) => (
                <>
                    <Bound
                        bound={bound}
                        key={index}
                        isOpenReturnBound={flightSearchParams?.openReturn && index === 1}
                    />
                    {index === 0 && parsedFlight.bounds.length > 1 && (
                        <hr className="my-2 mx-auto w-[50%]" />
                    )}
                </>
            ))}
            <FlightDetailModal
                isOpen={isOpen}
                toggle={toggle}
                flight={flight}
            />
        </div>
    );
};

export default FlightDetails;

const Bound = ({ bound, isOpenReturnBound }) => {
    const { t } = useTranslation();
    const { urls } = useApiClient();
    const airlineImg = `${process.env.REACT_APP_STATIC_URL}/${urls.flight.airlines}/${bound?.airline}.png`;
    return (
        <div className="flex   items-start justify-between  sm:items-center gap-2 w-full p-2 sm:p-0">
            <div className="  flex flex-col  items-center justify-center ">
                {isOpenReturnBound ? (
                    <div className="flex flex-col items-center justify-center text-center px-1">
                        <span className="text-xs font-semibold text-green-700 leading-tight">
                            {t("openReturn")}
                        </span>
                        {bound?.date && (
                            <>
                                <span className="text-xs text-green-600 mt-0.5">
                                    {t("until")}
                                </span>
                                <span className="text-xs text-green-600">
                                    {bound.date}
                                </span>
                            </>
                        )}
                    </div>
                ) : (
                    <>
                        <img
                            src={airlineImg}
                            className=" object-cover size-12"
                            alt="img"
                        />
                        <div className="text-sm font-semibold">
                            {bound?.airline_name}{" "}
                        </div>
                    </>
                )}
            </div>
            <div className="flex flex-col sm:flex-row  items-end sm:items-center flex-1">
                <div className="flex flex-col items-center flex-1">
                    <h3 className="font-semibold">{bound?.departure_time}</h3>
                    <h6 className="text-paragraph-color text-[14px] w-[150px] text-center ">
                        {bound?.departure_airport}
                    </h6>
                </div>
                <div className="flight_right_arrow hidden sm:flex flex-col items-center gap-1 mx-5">
                    <img src={flightIcon} alt="icon" />
                    {!isOpenReturnBound && <h6>{bound?.nbStops}</h6>}
                    {!isOpenReturnBound && <p>{bound?.duration}</p>}
                    {!isOpenReturnBound && <p>{bound?.date}</p>}
                </div>
                <div className="flex sm:hidden -translate-x-[20px] gap-3 my-3">
                    <div
                        className="position-relative border-main-color   "
                        style={{
                            width: "0px",
                            borderColor: "var(--main-color)",
                            border: "1px dashed",
                            height: "90px",
                        }}
                    >
                        <div className="icon-md  text-white rounded-circle position-absolute top-50 start-50 translate-middle flex-centered">
                            <FaPlane
                                size={20}
                                className="fa-fw text-main-color"
                                style={{ transform: "rotate(90deg)" }}
                            />
                        </div>
                    </div>
                    {!isOpenReturnBound && (
                        <div className="d-flex flex-column justify-content-center">
                            <div className="font-semibold text-[14px]">
                                {bound?.nbStops}
                            </div>
                            <p className="text-paragraph-color">
                                {bound?.duration2}
                            </p>
                            <p className=" text-[14px] text-paragraph-color">
                                {bound?.date}
                            </p>
                        </div>
                    )}
                </div>
                <div className="flex flex-col items-center flex-1">
                    <h3 className="font-semibold">{bound?.arrival_time}</h3>
                    <h6 className="text-paragraph-color text-[14px] w-[150px] text-center ">
                        {bound?.arrival_airport}
                    </h6>
                </div>
            </div>
        </div>
    );
};
